"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bbox_1 = __importDefault(require("@turf/bbox"));
function getEventsAndInteriorRings(collection, originalIdField) {
    var independentFeatures = [];
    var oidCounts = {};
    if (originalIdField) {
        for (var _i = 0, _a = collection.features; _i < _a.length; _i++) {
            var feature = _a[_i];
            if (feature.properties && feature.properties[originalIdField]) {
                var key = feature.properties[originalIdField];
                oidCounts[key] = (oidCounts[key] || 0) + 1;
            }
        }
    }
    var bboxes = [];
    var idSequence = 0;
    var polygonIdSequence = 0;
    var events = [];
    var interiorRings = {};
    for (var fi = 0; fi < collection.features.length; fi++) {
        var feature = collection.features[fi];
        if (originalIdField &&
            feature.properties &&
            feature.properties[originalIdField] &&
            oidCounts[feature.properties[originalIdField]] === 1) {
            independentFeatures.push(feature);
            continue;
        }
        var bbox = feature.bbox || bbox_1.default(feature);
        bboxes.push(bbox);
        var polygons = void 0;
        if (feature.geometry.type === "Polygon") {
            polygons = [feature.geometry.coordinates];
        }
        else {
            polygons = feature.geometry.coordinates;
        }
        var _loop_1 = function (polygon) {
            var polygonId = polygonIdSequence++;
            interiorRings[polygonId] = polygon.slice(1);
            var exteriorRing = polygon[0];
            var firstEvent = null;
            var previousEvent = null;
            var _loop_2 = function () {
                var position = exteriorRing[i];
                if (previousEvent &&
                    previousEvent.position[0] === position[0] &&
                    previousEvent.position[1] === position[1]) {
                    var removed = events.pop();
                    if (firstEvent && firstEvent === removed) {
                        firstEvent = null;
                        previousEvent = null;
                    }
                    else {
                        previousEvent = events[events.length - 1];
                    }
                }
                if (i === exteriorRing.length - 1) {
                    previousEvent.next = firstEvent;
                    firstEvent.trailingCoordinates = __spreadArrays(exteriorRing.slice(previousEvent.index + 1, i), firstEvent.trailingCoordinates);
                    return "break";
                }
                var onLeft = position[0] === bbox[0];
                var onRight = position[0] === bbox[2];
                var onBottom = position[1] === bbox[1];
                var onTop = position[1] === bbox[3];
                if (onLeft ||
                    onRight ||
                    onTop ||
                    onBottom ||
                    i === exteriorRing.length - 1) {
                    var isRightAngle = function () {
                        var before = exteriorRing[i - 1];
                        var after = exteriorRing[i + 1];
                        if (i === 0) {
                            before = exteriorRing[exteriorRing.length - 2];
                        }
                        else if (i === exteriorRing.length - 1) {
                            after = exteriorRing[1];
                        }
                        return isNinetyDegrees(position, before, after);
                    };
                    var onCorner = (onLeft && onBottom) ||
                        (onBottom && onRight) ||
                        (onTop && onRight) ||
                        (onTop && onLeft);
                    var e = {
                        id: idSequence++,
                        position: position,
                        featureId: fi,
                        polygonId: polygonId,
                        index: i,
                        trailingCoordinates: [],
                        isNinetyDegreeCorner: onCorner && isRightAngle(),
                        onCorner: onCorner,
                        next: null,
                    };
                    if (previousEvent) {
                        previousEvent.next = e;
                        e.trailingCoordinates = exteriorRing.slice(previousEvent.index + 1, i);
                    }
                    else {
                        e.trailingCoordinates = exteriorRing.slice(0, i);
                        firstEvent = e;
                    }
                    events.push(e);
                    previousEvent = e;
                }
            };
            for (var i = 0; i < exteriorRing.length; i++) {
                var state_1 = _loop_2();
                if (state_1 === "break")
                    break;
            }
        };
        for (var _b = 0, polygons_1 = polygons; _b < polygons_1.length; _b++) {
            var polygon = polygons_1[_b];
            _loop_1(polygon);
        }
    }
    return {
        events: events,
        interiorRings: interiorRings,
        bboxes: bboxes,
        independentFeatures: independentFeatures,
    };
}
exports.default = getEventsAndInteriorRings;
function isNinetyDegrees(center, before, after) {
    return ((before[0] === center[0] && after[1] === center[1]) ||
        (before[1] === center[1] && after[0] === center[0]));
}
